import { FC } from 'react';

import {
  FiletypeAudio,
  FiletypeCode,
  FiletypeDocument,
  FiletypeImage,
  FiletypeSpreadsheet,
  FiletypeVideo,
} from './Icons';
import { IIconProps } from './icons.interface';

import { FileTypeCategory } from 'utils/attachments';

const FILE_TYPE_ICON: Record<FileTypeCategory, FC<IIconProps>> = {
  image: FiletypeImage,
  video: FiletypeVideo,
  audio: FiletypeAudio,
  code: FiletypeCode,
  document: FiletypeDocument,
  spreadsheet: FiletypeSpreadsheet,
};

export { FILE_TYPE_ICON };
